module.exports = __webpack_public_path__ + "img/icon-account-email@3x.d5fa93dc.png";